export default __webpack_public_path__ + "static/media/register_bakcground.ec0485ba.png";